import type { ActionMetrics, ActionModel } from '@jet/environment';
import type {
    EmptyAction,
    CompoundAction,
} from '@jet/environment/models/actions';

export function isEmptyAction(
    action: ActionModel | null,
): action is EmptyAction {
    return action?.$kind === 'emptyAction';
}

export function makeEmptyAction(actionMetrics: ActionMetrics): EmptyAction {
    return {
        $kind: 'emptyAction',
        actionMetrics,
    };
}

export function isCompoundAction(
    action: ActionModel | null,
): action is CompoundAction {
    return action?.$kind === 'compoundAction';
}

export function makeCompoundAction(
    actionMetrics: ActionMetrics,
    subactions: ActionModel[],
): CompoundAction {
    return {
        $kind: 'compoundAction',
        subactions,
        actionMetrics,
    };
}

export type {
    EmptyAction,
    CompoundAction,
} from '@jet/environment/models/actions';
